<script lang="ts">
  import * as SavedProductsService from "@retailer/svelte/Cart/SavedForLater/Api.svelte";

  import type { SavedProductType } from "@shared/types/SavedProducts";

  export let cartService: any;
  export let distributorName: string;
  export let isMobile: boolean = false;
  export let products: SavedProductType[];
  export let showLoading: boolean = false;

  let distributor = products[0].distributor;

  function moveOrderToCart(distributorName: string) {
    if (allInventoryDeleted(products)) {
      return;
    }
    showLoading = true;
    SavedProductsService.moveOrderToCart(cartService, distributorName);
  }

  const allInventoryDeleted = (savedProductsForDistributor: SavedProductType[]) => {
    return savedProductsForDistributor.every(sp => sp.deleted_at || sp.deleted);
  };

</script>

{#if distributor}
  <div class="fizz-flex-row fizz-border-top fizz-inset-square-12">
    {#if !isMobile}
      <div class="fizz-flex-item fizz-full-width" />
    {/if}
    <div class="fizz-flex-row fizz-space-between" class:fizz-full-width={isMobile}>
      <button
        disabled={showLoading}
        class:fizz-disabled={allInventoryDeleted(products)}
        data-testid="product-total"
        class="fizz-button fizz-button-small fizz-button-icon move-all-to-cart-btn-test-hook fizz-flex-item"
        on:click={() => moveOrderToCart(distributorName)}
      >
        <span>Move all items to cart</span>
      </button>
    </div>
  </div>
{/if}
